module.exports = "/pagoEfectivo.ff3a422c73c389421b4453b593675b04.png";